var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmotionsFearful = function SvgEmotionsFearful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#emotions-fearful_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.333 7.5A1.667 1.667 0 1 1 5 7.5a1.667 1.667 0 0 1 3.333 0ZM15 7.5a1.667 1.667 0 1 1-3.333 0A1.667 1.667 0 0 1 15 7.5Zm-5 4.167A3.333 3.333 0 0 0 6.667 15h6.666A3.333 3.333 0 0 0 10 11.667Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "emotions-fearful_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 2.708 7.292) scale(15.4167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#6BEBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077EA4"
  })))));
};
export default SvgEmotionsFearful;